import Cookies from 'js-cookie';
import {useMutation} from 'react-query';

import {auth} from '../ApiClient';
import {apiEndpoints, ENV_STAGES} from '../constants/ApiConstants';
import {IPosSessionParams, IPosSessionResponse} from '../types/UserAuth.types';
import {currentHostName} from '@amzn/rangoli-seller-desktop-async-call-wrapper/src/index';

export function useGetPosSessionIdMutation() {
  return useMutation<IPosSessionResponse, Error>(getPosSessionId);
}

export async function getPosSessionId(): Promise<IPosSessionResponse> {
  const shopIdFromStorage = localStorage.getItem('shopId');
  const shopId = shopIdFromStorage ? +shopIdFromStorage : 0;
  const posSessionParams: IPosSessionParams = {
    shopId: shopId,
    tillNumber: -3,
  };
  const response = (await auth.post(`${apiEndpoints.posSession}`, posSessionParams))
    .data;

  if (currentHostName === ENV_STAGES.PROD) {
    Cookies.set('posSessionId', response?.posSessionId, {domain: '.amazon.in'});
    localStorage.setItem('userId', response?.userId);
  } else {
    Cookies.set('posSessionId', response?.posSessionId, {domain: '.amazon.com'});
    localStorage.setItem('userId', response?.userId)
  }
  return response;
}
